export default "skymp5-front/bcbf38a48fe84a5bf9ee14778d6833e2.mp3";